import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import CPContent from './CPContent'

const ChangePassword = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                       
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <CPContent />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default ChangePassword